module.exports = __webpack_public_path__ + "img/back-1-2180e2ce.png";